import { mdiBookClock, mdiCashSync, mdiClipboardTextClock, mdiMonitorAccount } from "@mdi/js";
import Icon from "@mdi/react";
import "animate.css";

import { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Faq() {
    useEffect(() => {
        AOS.init({ once: true });
    }, []);
    return (
        <section id="portfolio" className="portfolio section">
            <div className="container section-title" data-aos="fade-up">
                <div>
                    <span> Perguntas Frequentes</span> <span className="description-title">(FAQ) </span>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <section className="p-4 d-flex justify-content-center w-100">
                        <div className="row mx-5 text-center">
                            {/* FAQ Item 1 */}
                            <div className="col-12 col-sm-6 mb-4 my-3 " data-aos="fade-right">
                                <p>
                                    <Icon path={mdiClipboardTextClock} size={4} />
                                </p>
                                <h6 className="mb-3 text-primary">
                                    {" "}
                                    <i className="far fa-paper-plane text-primary pe-2"></i> Vocês trabalham com escopo
                                    fechado e também por horas?
                                </h6>
                                <p>Sim. Definimos juntos a melhor forma conforme urgência e complexidade.</p>
                            </div>

                            {/* FAQ Item 2 */}
                            <div className="col-12 col-sm-6 mb-4 my-3 " data-aos="fade-right">
                                <p>
                                    <Icon path={mdiMonitorAccount} size={4} />
                                </p>
                                <h6 className="mb-3 text-primary">
                                    {" "}
                                    <i className="far fa-paper-plane text-primary pe-2"></i> Como é a comunicação no dia
                                    a dia?
                                </h6>
                                <p>WhatsApp/Slack e checkpoints semanais por Meet.</p>
                            </div>

                            {/* FAQ Item 3 */}
                            <div className="col-12 col-sm-6 mb-4 my-3" data-aos="fade-left">
                                <p>
                                    <Icon path={mdiBookClock} size={4} />
                                </p>
                                <h6 className="mb-3 text-primary">
                                    {" "}
                                    <i className="far fa-paper-plane text-primary pe-2"></i>Quais prazos costumam
                                    trabalhar?
                                </h6>
                                <p>Variam por projeto, mas sempre com entregas parciais para gerar valor cedo.</p>
                            </div>

                            {/* FAQ Item 4 */}
                            <div className="col-12 col-sm-6 mb-4 my-3" data-aos="fade-left">
                                <p>
                                    <Icon path={mdiCashSync} size={4} />
                                </p>
                                <h6 className="mb-3 text-primary">
                                    {" "}
                                    <i className="far fa-paper-plane text-primary pe-2"></i>Como funcionam os
                                    pagamentos?
                                </h6>
                                <p>PIX ou boleto— com emissão de NF PJ.</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </section>
    );
}
